/**
 * Emails / SMS / call logs are keyed by split request when the communication
 * panel is opened from debt recovery, and by contract when it is opened from
 * contract details. Build the id param the APIs expect for whichever record
 * the panel belongs to.
 */
export interface CommunicationRef {
  split_req_id?: any;
  contract_id?: any;
}

export function buildCommunicationRef(split_req_id: any, contract_id: any): CommunicationRef {
  return contract_id ? { contract_id } : { split_req_id };
}

/** Read the ref back out of an existing payload (e.g. a modal's `name_list`). */
export function pickCommunicationRef(source: any): CommunicationRef {
  return buildCommunicationRef(source?.split_req_id ?? null, source?.contract_id ?? null);
}
